module.exports = __webpack_public_path__ + "static/genaiz-logo-inverted-d2db786bd54be38dcaef9b1586a08976.svg";